export class CalendarFilterEvent {

    private _numAppts: number = 1;
    public get numAppts(): number {
        return this._numAppts;
    } public set numAppts(value: number) {
        this._numAppts = value;
    }

    private _soonest: boolean = false;
    public get soonest(): boolean {
        return this._soonest;
    } public set soonest(value: boolean) {
        this._soonest = value;
    }

    constructor(appts: number = 1, soonest: boolean = false) {
        this._numAppts = appts;
        this._soonest = soonest;
    }
}
